import React, { createContext, useState, ReactNode, FC } from "react";
import { AlertProps } from "../layout/layoutType";
import { Debug } from "@/util/debug";

export const AlertContext = createContext<AlertProps>({
  open: false,
  title: undefined,
  description: undefined,
  useCancel: undefined,
  useOk: undefined,
  cancelTitle: undefined,
  okTitle: undefined,
  okClose: undefined,
});

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: FC<AlertProviderProps> = ({ children }) => {
  const [prop, setProp] = useState<AlertProps>({
    open: false,
    title: undefined,
    description: undefined,
    useCancel: undefined,
    useOk: undefined,
    cancelTitle: undefined,
    okTitle: undefined,
    okClose: undefined,
  });
  const alertSetting = (prop: AlertProps) => {
    Debug(prop);
    setProp(() => prop);
  };

  const value: AlertProps = { ...prop, setProp: alertSetting };

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
};
